export enum TimezoneShortEnum {
  AKDT = 'AKDT',
  AKST = 'AKST',
  AST = 'AST',
  CST = 'CST',
  CDT = 'CDT',
  EDT = 'EDT',
  EST = 'EST',
  HDT = 'HDT',
  HST = 'HST',
  MDT = 'MDT',
  MST = 'MST',
  PDT = 'PDT',
  PST = 'PST',
}
